import { Brand } from '../../../../enum/brand';
import { EquipmentOption } from '../../../../vehicle/model/equipmentOption';
export class VehicleV10 {
    static fromRawData(rawData) {
        var _a;
        const vehicleState = rawData.vehicleState;
        const vehicleSpec = vehicleState.vehicleSpecification;
        const typeInfo = vehicleSpec.typeInformation;
        const vinShort = vehicleSpec.vehicleIdentification.vinShort;
        const vinLongPrefix = vehicleSpec.vehicleIdentification.vinLongPrefix;
        const vehicle = new this(vinLongPrefix + vinShort);
        if (vehicleSpec.brand in Brand) {
            vehicle.brand = Brand[vehicleSpec.brand];
        }
        else if (vehicleSpec.brand === 'BMW_I') {
            vehicle.brand = Brand.BMW_i;
        }
        else {
            vehicle.brand = Brand.UNKNOWN;
        }
        if (vehicleSpec.prodArt === '1') {
            vehicle.vehicleType = "PASSENGER_CAR";
        }
        else if (vehicleSpec.prodArt === '0') {
            vehicle.vehicleType = "MOTORCYCLE";
        }
        else {
            vehicle.vehicleType = "UNKNOWN";
        }
        if (vehicle.brand === Brand.MOT) {
            vehicle.steering = "MOTORCYCLE";
        }
        else if (typeInfo.steering === 'LL') {
            vehicle.steering = "LEFT_HAND_DRIVE";
        }
        else if (typeInfo.steering === 'RL') {
            vehicle.steering = "RIGHT_HAND_DRIVE";
        }
        else {
            vehicle.steering = "UNKNOWN";
        }
        if (typeInfo.gear === 'AUT') {
            vehicle.transmissionType = "AUTOMATIC_TRANSMISSION";
        }
        else if (typeInfo.gear === 'MECH') {
            vehicle.transmissionType = "MANUAL_TRANSMISSION";
        }
        else {
            vehicle.transmissionType = "UNKNOWN";
        }
        if (typeInfo.drive === 'ALLR') {
            vehicle.driveType = "ALL_WHEEL_DRIVE";
        }
        else if (typeInfo.drive === 'FRONT') {
            vehicle.driveType = "FRONT_WHEEL_DRIVE";
        }
        else if (typeInfo.drive === 'HECK') {
            vehicle.driveType = "REAR_WHEEL_DRIVE";
        }
        else if (typeInfo.drive === 'KAR') {
            vehicle.driveType = "SHAFT_DRIVE";
        }
        else {
            vehicle.driveType = "UNKNOWN";
        }
        if (vehicleState.firstRegistration && vehicleState.firstRegistration.firstRegistrationDate) {
            vehicle.firstRegistrationDate = new Date(vehicleState.firstRegistration.firstRegistrationDate.split('[')[0]);
        }
        const paintEquipment = EquipmentOption.extractFirstFromRawData(vehicleState.specialEquipments, 'L');
        vehicle.paintNumber = paintEquipment === null || paintEquipment === void 0 ? void 0 : paintEquipment.getCode();
        vehicle.paint = paintEquipment === null || paintEquipment === void 0 ? void 0 : paintEquipment.getDescription();
        const upholsteryEquipment = EquipmentOption.extractFirstFromRawData(vehicleState.specialEquipments, 'P');
        vehicle.upholsteryCode = upholsteryEquipment === null || upholsteryEquipment === void 0 ? void 0 : upholsteryEquipment.getCode();
        vehicle.upholstery = upholsteryEquipment === null || upholsteryEquipment === void 0 ? void 0 : upholsteryEquipment.getDescription();
        vehicle.equipmentOptions = EquipmentOption.fromRawData(vehicleState.specialEquipments);
        vehicle.baseTypeCode = typeInfo.baseType;
        vehicle.typeCode = typeInfo.type;
        vehicle.mileageInKilometers = (_a = vehicleState.mileage) === null || _a === void 0 ? void 0 : _a.mileage;
        vehicle.modelDesignation = typeInfo.model;
        vehicle.productionDate = new Date(vehicleSpec.productionDate.split('[')[0]);
        if (vehicleState.ILevel) {
            vehicle.integrationLevelCurrent = VehicleV10.getStringOrNull(vehicleState.ILevel.integrationLevel);
        }
        else {
            vehicle.integrationLevelCurrent = null;
        }
        vehicle.integrationLevelExWorks = VehicleV10.getStringOrNull(vehicleSpec.ILevelExworks);
        vehicle.engineNumber = vehicleSpec.engineNumber;
        vehicle.developmentSeries = vehicleSpec.eseries;
        vehicle.transmissionNumber = vehicleSpec.gearNumber;
        vehicle.imageUrlSmall = rawData.imageUrlSmall ? rawData.imageUrlSmall : null;
        vehicle.imageUrlLarge = rawData.imageUrlLarge ? rawData.imageUrlLarge : null;
        vehicle.hasWarningFlag = rawData.vehicleWarnings.hasWarning;
        vehicle.hasStopFlag = rawData.vehicleWarnings.hasStop;
        vehicle.capacity = VehicleV10.getPositiveNumberOrNull(typeInfo.cubicCapacity);
        vehicle.capacityUnit = 'l';
        vehicle.power = typeInfo.power;
        vehicle.powerUnit = 'kw';
        vehicle.validFrom = null;
        vehicle.validUntil = null;
        vehicle.bodyType = typeInfo.bodyType;
        vehicle.engineType = VehicleV10.getStringOrNull(typeInfo.engine);
        vehicle.marketVersion = VehicleV10.getStringOrNull(typeInfo.country);
        vehicle.leadType = typeInfo.leadType;
        vehicle.modelSeries = null;
        vehicle.electricMotor = null;
        vehicle.rawData = rawData;
        return vehicle;
    }
    static createVirtualVehicle(rawData) {
        const vehicle = new this(undefined);
        vehicle.brand = this.mapBrand(rawData.typeAttributes.brand[0].searchTerm);
        vehicle.modelSeries = rawData.typeAttributes.modelSeries[0].displayTerm;
        vehicle.developmentSeries = rawData.typeAttributes.developmentCode[0].displayTerm;
        vehicle.modelDesignation = rawData.typeAttributes.model[0].displayTerm;
        vehicle.marketVersion = rawData.typeAttributes.market[0].displayTerm;
        if (vehicle.brand === Brand.MOT) {
            vehicle.vehicleType = "MOTORCYCLE";
            vehicle.steering = "MOTORCYCLE";
        }
        else {
            vehicle.vehicleType = "PASSENGER_CAR";
            vehicle.bodyType = rawData.typeAttributes.body[0].displayTerm;
            vehicle.engineType = rawData.typeAttributes.engine[0].displayTerm;
            vehicle.electricMotor = rawData.typeAttributes.electricMotor[0].displayTerm;
            vehicle.steering = this.mapSteering(rawData.typeAttributes.steering[0].searchTerm);
            vehicle.transmissionType = this.mapTransmission(rawData.typeAttributes.transmission[0].searchTerm);
        }
        vehicle.typeCode = rawData.typeCodes[0].typekey;
        vehicle.baseTypeCode = rawData.typeCodes[0].baseType;
        vehicle.capacity = rawData.typeCodes[0].capacity;
        vehicle.capacityUnit = rawData.typeCodes[0].capacityUnit;
        vehicle.power = rawData.typeCodes[0].power;
        vehicle.powerUnit = rawData.typeCodes[0].powerUnit;
        vehicle.validFrom = rawData.typeCodes[0].validFrom;
        vehicle.validUntil = rawData.typeCodes[0].validUntil;
        return vehicle;
    }
    static mapBrand(brand) {
        let virtualVehicleBrand = Brand.UNKNOWN;
        if (brand === 'BMW') {
            virtualVehicleBrand = Brand.BMW;
        }
        else if (brand === 'BMW MOTORRAD') {
            virtualVehicleBrand = Brand.MOT;
        }
        else if (brand === 'BMWi') {
            virtualVehicleBrand = Brand.BMW_i;
        }
        else if (brand === 'MINI') {
            virtualVehicleBrand = Brand.MINI;
        }
        else if (brand === 'ROLLS ROYCE') {
            virtualVehicleBrand = Brand.RR;
        }
        else if (brand === 'ZINORO') {
            virtualVehicleBrand = Brand.ZINORO;
        }
        return virtualVehicleBrand;
    }
    static mapSteering(steering) {
        let virtualVehicleSteering = "UNKNOWN";
        if (steering === 'LL') {
            virtualVehicleSteering = "LEFT_HAND_DRIVE";
        }
        else if (steering === 'RL') {
            virtualVehicleSteering = "RIGHT_HAND_DRIVE";
        }
        return virtualVehicleSteering;
    }
    static mapTransmission(transmission) {
        let virtualVehicleTransmission = "UNKNOWN";
        if (transmission === 'AUT') {
            virtualVehicleTransmission = "AUTOMATIC_TRANSMISSION";
        }
        else if (transmission === 'MECH') {
            virtualVehicleTransmission = "MANUAL_TRANSMISSION";
        }
        return virtualVehicleTransmission;
    }
    static getStringOrNull(field) {
        return field && field !== '' ? field : null;
    }
    static getPositiveNumberOrNull(field) {
        return field && field > 0 ? field : null;
    }
    constructor(vin) {
        this.vehicleType = "UNKNOWN";
        this.brand = Brand.UNKNOWN;
        this.modelDesignation = null;
        this.steering = "UNKNOWN";
        this.transmissionType = "UNKNOWN";
        this.driveType = "UNKNOWN";
        this.baseTypeCode = null;
        this.typeCode = null;
        this.equipmentOptions = [];
        this.developmentSeries = null;
        this.imageUrlSmall = null;
        this.imageUrlLarge = null;
        this.capacity = null;
        this.capacityUnit = null;
        this.power = null;
        this.powerUnit = null;
        this.validFrom = null;
        this.validUntil = null;
        this.bodyType = null;
        this.engineType = null;
        this.marketVersion = null;
        this.modelSeries = null;
        this.electricMotor = null;
        if (vin) {
            if (vin.length === 17) {
                this.vin = vin;
                this.vin7 = vin.slice(vin.length - 7);
            }
            else {
                throw new Error('Invalid VIN. Expected 17 digits but received: ' + vin.length);
            }
        }
        else {
            this.vin = undefined;
            this.vin7 = undefined;
        }
    }
    getTypeCode() {
        return this.typeCode;
    }
    getBaseTypeCode() {
        return this.baseTypeCode;
    }
    getBrand() {
        return this.brand;
    }
    getEquipmentOptions() {
        return this.equipmentOptions;
    }
    getModelDesignation() {
        return this.modelDesignation;
    }
    getSteering() {
        return this.steering;
    }
    getTransmissionType() {
        return this.transmissionType;
    }
    getDriveType() {
        return this.driveType;
    }
    getProductionDate() {
        return this.productionDate;
    }
    getVehicleType() {
        return this.vehicleType;
    }
    getVin() {
        return this.vin;
    }
    getVin7() {
        return this.vin7;
    }
    getPaint() {
        return this.paint;
    }
    getMileageInKilometers() {
        return this.mileageInKilometers;
    }
    getPaintNumber() {
        return this.paintNumber;
    }
    getUpholstery() {
        return this.upholstery;
    }
    getUpholsteryCode() {
        return this.upholsteryCode;
    }
    getCapacity() {
        return this.capacity;
    }
    getCapacityUnit() {
        return this.capacityUnit;
    }
    getDevelopmentSeries() {
        return this.developmentSeries;
    }
    getEngineNumber() {
        return this.engineNumber;
    }
    getHasStopFlag() {
        return this.hasStopFlag;
    }
    getHasWarningFlag() {
        return this.hasWarningFlag;
    }
    getImageUrlLarge() {
        return this.imageUrlLarge;
    }
    getImageUrlSmall() {
        return this.imageUrlSmall;
    }
    getIntegrationLevelCurrent() {
        return this.integrationLevelCurrent;
    }
    getIntegrationLevelExWorks() {
        return this.integrationLevelExWorks;
    }
    getPower() {
        return this.power;
    }
    getPowerUnit() {
        return this.powerUnit;
    }
    getTransmissionNumber() {
        return this.transmissionNumber;
    }
    getValidFrom() {
        return this.validFrom;
    }
    getValidUntil() {
        return this.validUntil;
    }
    getBodyType() {
        return this.bodyType;
    }
    getEngineType() {
        return this.engineType;
    }
    getMarketVersion() {
        return this.marketVersion;
    }
    getLeadType() {
        return this.leadType;
    }
    getModelSeries() {
        return this.modelSeries;
    }
    getElectricMotor() {
        return this.electricMotor;
    }
}
VehicleV10.fromPlainObject = (sourceVehicle) => {
    let targetVehicle = new VehicleV10(sourceVehicle.vin);
    targetVehicle = Object.assign(targetVehicle, sourceVehicle);
    if (sourceVehicle.equipmentOptions) {
        targetVehicle.equipmentOptions = EquipmentOption.fromPlainObjectList(sourceVehicle.equipmentOptions);
    }
    return targetVehicle;
};
//# sourceMappingURL=vehicleV10.js.map